module.exports = __webpack_public_path__ + "img/400@2x.eed4d351.png";